<div class="login-page">
  <div class="login-page__bg"></div>

  <div class="login-page__body">
    <div class="login-card">
      <router-outlet></router-outlet>
    </div>
    <p class="login-copyright">&copy; 2026 KAIZEN, Inc. All rights reserved. | <a href="#">Privacy</a></p>
  </div>

  <footer class="login-footer" aria-label="Footer">
    <div class="login-footer__inner">
       <div class="footer-left">
     
      <span class="footer-label">Powered by</span>
      <img src="./../../assets/logo.png" alt="AYAN Softwares" class="footer-logo" />
   
    </div>

      <div class="login-footer__center">
        <span class="login-footer__label">Also, available on</span>
        <div class="login-footer__badges">
          <a
            class="login-footer__badge-link"
            href="https://chromewebstore.google.com/detail/kaizen-esign/adhcdcjkdfniafmfahnlijlpdlmcdhog"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/assets/Chrome_icon.png" alt="Chrome Web Store" class="login-footer__badge" />
          </a>
          <a
            class="login-footer__badge-link"
            href="https://play.google.com/store/apps/details?id=com.ayankaizen.esign"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/assets/Google_Icon.png" alt="Google Play" class="login-footer__badge" />
          </a>
          <a
            class="login-footer__badge-link"
            href="https://apps.apple.com/in/iphone/search?term=kaizen%20esign"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/assets/AppStore_Icon.png" alt="App Store" class="login-footer__badge" />
          </a>
          <a
            class="login-footer__badge-link"
            href="https://marketplace.microsoft.com/en-us/product/office/WA200008076?tab=Overview"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/assets/Outlook.png" alt="Outlook" class="login-footer__badge" />
          </a>
        </div>
      </div>

      <!--
      <div class="login-footer__right">
        <span class="login-footer__compliance">Legally Compliant with</span>
        <div class="login-footer__compliance-logos">
          <img src="/assets/dsc_logo.png" alt="DSC" class="login-footer__compliance-img" />
          <img src="/assets/AATL-LOGO-latest1.png" alt="Adobe AATL" class="login-footer__compliance-img" />
        </div>
      </div>
      -->
    </div>

    <div class="login-footer__line">
      <img src="/assets/footer_horizontal_Line.png" alt="" />
    </div>
  </footer>
</div>
